/* The Misk Shoppe Layering Studio. Shared by the RDA design preview (window.MS_LAYER.data inline, live:false)
   and the live theme section (window.MS_LAYER = {dataUrl, variants, live:true}). Source: layering-kit/src. */
(function(){
const CFG = window.MS_LAYER || {};
const root = document.querySelector('.msls');
if(!root) return;
const $ = k => root.querySelector(`[data-ls="${k}"]`);

const boot = ACCORDS => {
const TIERS=[{id:'top',name:'Top Accords',short:'Top',sub:'The opening'},{id:'heart',name:'Heart Accords',short:'Heart',sub:'The character'},{id:'base',name:'Base Accords',short:'Base',sub:'Depth and lasting trail'}];
const WEIGHT={top:25,heart:40,base:35};
const MAX=7, INCLUDED=5, MINP=5, MAXP=70;
// Prices in cents. Live: from the product's variants (Size × Accords). Preview: the agreed price list.
const FALLBACK={'50|5':9000,'50|6':10000,'50|7':11000,'100|5':13500,'100|6':14500,'100|7':15500};
const VARIANTS=CFG.variants||{};
const SIZES=[{id:'50',ml:'50 ml'},{id:'100',ml:'100 ml'}];
const byId=Object.fromEntries(ACCORDS.map(a=>[a.id,a]));
const KEY={rose:'rose-aura',amber:'amber-glow',musk:'musk-cloud',marine:'marine-horizon',sandalwood:'sandalwood-sanctuary',leather:'leather-noir',coconut:'coconut-glow',oud:'oud-majlis','light oud':'oud-majlis',jasmine:'jasmine-veil',tonka:'tonka-obsession',candy:'candy-cloud',mandarin:'mandarin-halo',lemon:'sunlit-lemon',tuberose:'tuberose-velvet',freesia:'freesia-meadow',patchouli:'patchouli-ember',lavender:'lavender-spring',myrrh:'myrrh-ritual',spice:'velvet-spice',vanilla:'tonka-obsession'};
ACCORDS.forEach(a=>{a.pairs=new Set(a.best.split(',').map(s=>KEY[s.trim().toLowerCase().replace(/\.$/,'')]).filter(Boolean).filter(x=>x!==a.id));});
const linked=(a,b)=>byId[a].pairs.has(b)||byId[b].pairs.has(a);

const st={size:null,sel:[],touched:false,name:'',by:''};
const esc=s=>String(s).replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
const fmt=n=>(Math.round(n*2)/2).toFixed(n%1?1:0);
const cur=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD';
const money=c=>{const whole=c%100===0;try{return new Intl.NumberFormat(undefined,{style:'currency',currency:cur,minimumFractionDigits:whole?0:2,maximumFractionDigits:whole?0:2}).format(c/100);}catch(e){return '$'+(c/100).toFixed(whole?0:2);}};
const tierKey=n=>n<=INCLUDED?'5':String(n);
const variantFor=(size,n)=>VARIANTS[`${size}|${tierKey(n)}`];
const centsFor=(size,n)=>{const v=variantFor(size,n);return v?v.price:FALLBACK[`${size}|${tierKey(n)}`];};
const total=()=>Math.round(st.sel.reduce((t,s)=>t+s.pct,0)*2)/2;
const inTier=t=>st.sel.filter(s=>s.tier===t);
const price=()=>centsFor(st.size||'50',Math.max(st.sel.length,1));
const extraEach=()=>centsFor('50',6)-centsFor('50',5);
const ready=()=>({size:!!st.size,top:inTier('top').length>0,heart:inTier('heart').length>0,base:inTier('base').length>0,total:st.sel.length>0&&total()===100});
const isReady=()=>Object.values(ready()).every(Boolean);
const tierName=id=>TIERS.find(t=>t.id===id).short;

function autoBalance(){
  const present=TIERS.map(t=>t.id).filter(t=>inTier(t).length);
  if(!present.length)return;
  const sumW=present.reduce((a,t)=>a+WEIGHT[t],0);
  let left=200;                                   // work in half-percent units
  present.forEach((t,i)=>{
    const units=i===present.length-1?left:Math.round(200*WEIGHT[t]/sumW);left-=units;
    const items=inTier(t),base=Math.floor(units/items.length);let rem=units-base*items.length;
    items.forEach(s=>{s.pct=(base+(rem-->0?1:0))/2;});
  });
}
function blockReason(a,tier){
  const other=st.sel.find(s=>s.id===a.id&&s.tier!==tier);
  if(other)return 'Already chosen as a '+tierName(other.tier)+' accord';
  if(!st.sel.some(s=>s.id===a.id&&s.tier===tier)&&st.sel.length>=MAX)return 'Maximum of seven accords reached';
  return '';
}
function toggle(id,tier){
  const i=st.sel.findIndex(s=>s.id===id&&s.tier===tier);
  if(i>=0)st.sel.splice(i,1);
  else{ if(blockReason(byId[id],tier))return; st.sel.push({id,tier,pct:MINP}); }
  if(!st.touched)autoBalance();
  render();
}
function setPct(idx,v){st.touched=true;st.sel[idx].pct=Math.min(MAXP,Math.max(MINP,Math.round(v*2)/2));render(true);}

/* ---------- bottle ---------- */
let uid=0;
function bottle(w,label){
  const H=w*1.5, x0=w*0.14,x1=w*0.86,y0=H*0.3,y1=H*0.97, ih=(y1-y0)-w*0.1;
  const tot=total(), fill=Math.min(tot,100)/100;
  const order=[...inTier('base'),...inTier('heart'),...inTier('top')];
  const scale=tot>0?ih*fill/Math.max(tot,100):0;
  let y=y1-w*0.05, bands='';
  order.forEach(s=>{const h=s.pct*scale;y-=h;bands+=`<rect x="${x0}" y="${y}" width="${x1-x0}" height="${h+0.6}" fill="${byId[s.id].c}"/>`;});
  const name=esc(st.name||'My Signature Scent');
  const serif='style="font-family:var(--ls-serif)"', sans='style="font-family:var(--ls-sans)"';
  const lab=label?`<rect x="${w*0.24}" y="${H*0.52}" width="${w*0.52}" height="${H*0.25}" rx="3" fill="#FBF9F6" stroke="#A27C2E" stroke-width="1"/>
    <text x="${w/2}" y="${H*0.585}" text-anchor="middle" ${sans} font-size="${w*0.042}" letter-spacing="1.6" fill="#A27C2E">THE MISK SHOPPE</text>
    <line x1="${w*0.36}" x2="${w*0.64}" y1="${H*0.605}" y2="${H*0.605}" stroke="#A27C2E" stroke-width=".6"/>
    <text x="${w/2}" y="${H*0.66}" text-anchor="middle" ${serif} font-weight="600" font-size="${Math.min(w*0.082,w*0.9/Math.max(name.length,8)*1.15)}" fill="#241C16">${name}</text>
    <text x="${w/2}" y="${H*0.71}" text-anchor="middle" ${sans} font-size="${w*0.036}" fill="#6E6258">${esc(st.by?('by '+st.by):'Layering Studio')}</text>
    <text x="${w/2}" y="${H*0.75}" text-anchor="middle" ${sans} font-size="${w*0.034}" letter-spacing="1" fill="#6E6258">${st.size?st.size+' ML':''}</text>`:'';
  const id='lsb'+(++uid);
  return `<svg width="${w}" height="${H}" viewBox="0 0 ${w} ${H}" role="img" aria-label="Bottle preview">
  <defs><clipPath id="${id}"><rect x="${x0}" y="${y0}" width="${x1-x0}" height="${y1-y0}" rx="${w*0.07}"/></clipPath>
  <linearGradient id="${id}s" x1="0" x2="1"><stop offset="0" stop-color="#fff" stop-opacity=".55"/><stop offset=".18" stop-color="#fff" stop-opacity=".05"/><stop offset=".8" stop-color="#000" stop-opacity="0"/><stop offset="1" stop-color="#000" stop-opacity=".08"/></linearGradient>
  <linearGradient id="${id}c" x1="0" x2="1"><stop offset="0" stop-color="#8A6A27"/><stop offset=".45" stop-color="#E2C27A"/><stop offset="1" stop-color="#8A6A27"/></linearGradient></defs>
  <rect x="${w*0.36}" y="${H*0.04}" width="${w*0.28}" height="${H*0.17}" rx="${w*0.03}" fill="url(#${id}c)"/>
  <rect x="${w*0.41}" y="${H*0.2}" width="${w*0.18}" height="${H*0.11}" fill="#D9CDBB"/>
  <g clip-path="url(#${id})"><rect x="${x0}" y="${y0}" width="${x1-x0}" height="${y1-y0}" fill="#F7F3EC"/>${bands}<rect x="${x0}" y="${y0}" width="${x1-x0}" height="${y1-y0}" fill="url(#${id}s)"/></g>
  <rect x="${x0}" y="${y0}" width="${x1-x0}" height="${y1-y0}" rx="${w*0.07}" fill="none" stroke="${tot>100?'#B23A2C':'#CDBFAE'}" stroke-width="${tot>100?2:1.2}"/>
  ${lab}</svg>`;
}

/* ---------- renderers ---------- */
function renderSizes(){
  $('sizes').innerHTML=SIZES.map(s=>{const tall=s.id==='100';return `<button type="button" class="ls-size" data-size="${s.id}" aria-pressed="${st.size===s.id}">
    <span class="ls-tick"></span>
    <svg width="54" height="${tall?96:78}" viewBox="0 0 54 ${tall?96:78}" aria-hidden="true"><rect x="18" y="2" width="18" height="${tall?16:14}" rx="2" fill="#C79A3C"/><rect x="5" y="${tall?22:20}" width="44" height="${tall?72:56}" rx="7" fill="#F3EAD6" stroke="#CDBFAE"/></svg>
    <span><span class="ls-ml">${s.ml}</span><span class="ls-pr">${money(centsFor(s.id,5))}</span><span class="ls-inc">Up to 5 Signature Accords included</span></span></button>`;}).join('');
  $('extraTxt').textContent=money(extraEach());
}
function card(a,tier){
  const on=st.sel.some(s=>s.id===a.id&&s.tier===tier);
  const why=on?'':blockReason(a,tier);
  const pairWith=on||why?[]:st.sel.filter(s=>linked(s.id,a.id)).map(s=>byId[s.id].name);
  const flag=why?`<span class="ls-flag is-why">${why}</span>`:pairWith.length?`<span class="ls-flag is-pair">Pairs well with ${esc(pairWith.slice(0,2).join(' and '))}</span>`:'<span class="ls-flag"></span>';
  return `<div class="ls-acc${on?' is-sel':''}${why?' is-off':''}" data-id="${a.id}" data-tier="${tier}">
    <button type="button" class="ls-acc-main" aria-pressed="${on}"${why?' aria-disabled="true"':''}>
      <span class="ls-tick"></span>
      <span class="ls-acc-top"><span class="ls-orb" style="background:${a.c}"></span><span><span class="ls-acc-name">${a.name}</span><span class="ls-acc-fam">${a.fam}</span></span></span>
      <span class="ls-acc-desc">${a.desc}</span>
      <span class="ls-moods">${a.mood.split(' • ').slice(0,4).map(m=>`<span>${m}</span>`).join('')}</span>
    </button>
    <div class="ls-acc-foot">${flag}<button type="button" class="ls-more" aria-expanded="false">Notes</button></div>
    <div class="ls-detail"><dl>
      <dt>Top</dt><dd>${a.nt}</dd><dt>Heart</dt><dd>${a.nh}</dd><dt>Base</dt><dd>${a.nb}</dd>
      <dt>Best with</dt><dd>${a.best.replace(/\.$/,'')}</dd><dt>Effect</dt><dd>${a.effect}</dd><dt>Best for</dt><dd>${a.when}</dd></dl></div>
  </div>`;
}
function renderTiers(){
  const open=new Set([...root.querySelectorAll('.ls-acc.is-open')].map(e=>e.dataset.id+'|'+e.dataset.tier));
  $('tiers').innerHTML=TIERS.map(t=>{const list=ACCORDS.filter(a=>a.tiers.includes(t.id));const n=inTier(t.id).length;
    return `<div class="ls-tier"><div class="ls-tier-h"><h3>${t.name}<small>${t.sub}</small></h3><span>${n?n+' selected':'Choose at least one'}</span></div>
    <div class="ls-cards">${list.map(a=>card(a,t.id)).join('')}</div></div>`;}).join('');
  open.forEach(k=>{const [id,tier]=k.split('|');const el=root.querySelector(`.ls-acc[data-id="${id}"][data-tier="${tier}"]`);if(el){el.classList.add('is-open');el.querySelector('.ls-more').setAttribute('aria-expanded','true');}});
  const n=st.sel.length,r=ready(),ex=n-INCLUDED;
  $('counter').innerHTML=`<span><b>${n} of ${MAX}</b> accords</span>
    <span class="ls-pill${r.top?' is-ok':''}">Top ${inTier('top').length}</span><span class="ls-pill${r.heart?' is-ok':''}">Heart ${inTier('heart').length}</span><span class="ls-pill${r.base?' is-ok':''}">Base ${inTier('base').length}</span>
    <span style="color:var(--ls-muted)">${ex>0?`${ex} extra accord${ex>1?'s':''}, +${money(centsFor(st.size||'50',n)-centsFor(st.size||'50',5))}`:`${INCLUDED-Math.min(n,INCLUDED)} more included in the price`}</span>`;
}
function renderFormula(inPlace){
  const f=$('formula');
  if(!st.sel.length){f.innerHTML='<div class="ls-f-empty">Your formula appears here as you select accords.</div>';}
  else{
    const rows=['top','heart','base'].flatMap(t=>st.sel.map((s,i)=>({s,i})).filter(o=>o.s.tier===t));
    if(inPlace&&f.querySelector('.ls-f-row')){        // update in place so a dragged slider keeps hold
      rows.forEach(({s,i})=>{const row=f.querySelector(`.ls-f-row[data-i="${i}"]`);if(!row)return;row.querySelector('.ls-pct').textContent=fmt(s.pct)+'%';const r=row.querySelector('input');if(document.activeElement!==r)r.value=s.pct;row.querySelector('[data-d="-1"]').disabled=s.pct<=MINP;row.querySelector('[data-d="1"]').disabled=s.pct>=MAXP;});
    } else f.innerHTML=rows.map(({s,i})=>{const a=byId[s.id];return `<div class="ls-f-row" data-i="${i}">
      <div class="ls-f-name"><span class="ls-orb" style="background:${a.c}"></span><span>${a.name}</span></div>
      <div class="ls-pos">${tierName(s.tier)}</div>
      <div class="ls-ctl"><button type="button" class="ls-stp" data-d="-1" aria-label="Decrease ${a.name}"${s.pct<=MINP?' disabled':''}>&minus;</button><span class="ls-pct">${fmt(s.pct)}%</span><button type="button" class="ls-stp" data-d="1" aria-label="Increase ${a.name}"${s.pct>=MAXP?' disabled':''}>+</button>
        <input type="range" min="${MINP}" max="${MAXP}" step="0.5" value="${s.pct}" aria-label="${a.name} percentage"></div>
      <button type="button" class="ls-rm" aria-label="Remove ${a.name}">&times;</button></div>`;}).join('');
  }
  const t=total(), good=t===100&&st.sel.length>0;
  const tr=$('totalRead');tr.className='ls-total-read'+(good?' is-good':'');
  tr.textContent=good?'Formula Total: 100% ✓':`Formula Total: ${fmt(t)}% / 100%`+(t>100?` (reduce by ${fmt(t-100)}%)`:t>0?` (add ${fmt(100-t)}%)`:'');
  const b=$('bar');b.className='ls-bar'+(good?' is-good':'');b.firstElementChild.style.width=Math.min(t,100)+'%';
  $('autoBtn').disabled=!st.sel.length;
}
function aggregate(){
  const fam={},mood={};
  st.sel.forEach(s=>{const a=byId[s.id];a.fam.split(' • ').forEach(f=>{f=f.replace('Woods','Woody');fam[f]=(fam[f]||0)+s.pct;});a.mood.split(' • ').forEach(m=>{mood[m]=(mood[m]||0)+s.pct;});});
  const top=(o,n)=>Object.entries(o).sort((a,b)=>b[1]-a[1]).slice(0,n).map(x=>x[0]);
  return {fam:top(fam,5),mood:top(mood,4)};
}
function renderProfile(){
  const p=$('profile');
  if(!st.sel.length){p.innerHTML='<div class="ls-empty">Select accords to see your fragrance profile take shape.</div>';return;}
  const {fam,mood}=aggregate();
  const pairs=[];for(let i=0;i<st.sel.length;i++)for(let j=i+1;j<st.sel.length;j++)pairs.push(linked(st.sel[i].id,st.sel[j].id));
  const on=pairs.filter(Boolean).length;
  const pyr=TIERS.map(t=>{const l=inTier(t.id);return `<div><b>${t.short}</b><span>${l.length?l.map(s=>`${byId[s.id].name} ${fmt(s.pct)}%`).join(', '):'<em>Not yet chosen</em>'}</span></div>`;}).join('');
  p.innerHTML=`<div class="ls-profile"><div>${bottle(180,true)}</div><div>
    <div class="ls-tags">${fam.map(f=>`<span>${f}</span>`).join(' <span class="ls-dot">&bull;</span> ')}</div>
    <div class="ls-prof-sub">Character</div><div class="ls-mood-line">${mood.join(', ')}</div>
    <div class="ls-prof-sub">Structure</div><div class="ls-pyr">${pyr}</div>
    ${pairs.length?`<div class="ls-harmony"><span class="ls-dots">${pairs.map(x=>`<i class="${x?'is-on':''}"></i>`).join('')}</span><span><b>${on} of ${pairs.length}</b> pairings are recommended in our Layering Guide${on/pairs.length>=.5?'. A well-matched blend.':'. The green "pairs well" hints in step 2 point to safer combinations.'}</span></div>`:''}
  </div></div>`;
}
function renderSummary(){
  $('bottleBig').innerHTML=bottle(150,true);
  $('sumTitle').textContent=st.name||'My Signature Scent';
  $('sumBy').textContent=st.by?'Created by '+st.by:'';
  const n=st.sel.length, sz=st.size?SIZES.find(s=>s.id===st.size):null, ex=n-INCLUDED;
  $('sumList').innerHTML=`<li><span>Bottle</span><span>${sz?sz.ml+' &middot; '+money(centsFor(st.size,5)):'Not chosen'}</span></li>
    <li><span>Accords</span><span>${n} of ${MAX}${n?` &middot; ${inTier('top').length}T ${inTier('heart').length}H ${inTier('base').length}B`:''}</span></li>
    ${ex>0?`<li><span>Extra accords (${ex})</span><span>+${money(price()-centsFor(st.size||'50',5))}</span></li>`:''}
    <li><span>Formula</span><span>${fmt(total())}%</span></li>
    <li class="ls-tot"><span>Total</span><span>${sz?money(price()):'from '+money(price())}</span></li>`;
  const r=ready();
  $('checks').innerHTML=[['size','Bottle size chosen'],['top','At least one Top accord'],['heart','At least one Heart accord'],['base','At least one Base accord'],['total','Formula totals exactly 100%']].map(([k,l])=>`<li class="${r[k]?'is-ok':''}">${l}</li>`).join('');
  const ok=isReady();
  $('cartBtn').disabled=!ok;
  $('cartBtn').textContent=ok?`Add to cart · ${money(price())}`:'Add to cart';
  $('sumNote').textContent=ok?'Hand-blended to your formula.':'Complete the checklist to add your blend.';
  const t=total(),good=t===100&&n>0;
  $('mbl').innerHTML=`<b>${money(price())}</b> &middot; ${sz?sz.ml:'No bottle'} &middot; ${n} accord${n===1?'':'s'}<span class="ls-mb-t${good?' is-good':''}">${fmt(t)}%</span>`;
  $('mbBtn').textContent=ok?'Add to cart':'Review';
  const done={1:r.size,2:r.top&&r.heart&&r.base,3:r.total,4:!!st.name,5:ok};
  root.querySelectorAll('[data-ls="stepsNav"] button').forEach(b=>b.classList.toggle('is-done',!!done[b.dataset.s]));
}
function render(inPlace){renderSizes();renderTiers();renderFormula(inPlace);renderProfile();renderSummary();}

/* ---------- cart ---------- */
function properties(){
  const p={'Fragrance name':st.name||'My Signature Scent'};
  if(st.by)p['Created by']=st.by;
  TIERS.forEach(t=>inTier(t.id).forEach((s,i)=>{p[`${t.short} ${i+1}`]=`${byId[s.id].name} ${fmt(s.pct)}%`;}));
  p['_formula']=st.sel.map(s=>`${s.id}:${s.tier}:${fmt(s.pct)}`).join(',');   // machine-readable copy, hidden from the customer
  return p;
}
function openPreview(){
  const sz=SIZES.find(s=>s.id===st.size), props=properties();
  $('mItem').innerHTML=`<div style="flex:none">${bottle(70,false)}</div><div><div style="font-weight:500">Layering Studio Custom Blend &middot; ${sz.ml}</div>
    <div class="ls-props">${Object.entries(props).filter(([k])=>k[0]!=='_').map(([k,v])=>`<div><b>${esc(k)}:</b> ${esc(v)}</div>`).join('')}</div>
    <div style="margin-top:8px;font-weight:500">${money(price())}</div></div>`;
  $('modal').classList.add('is-on');$('mClose').focus();
}
let toastT;
function toast(msg,withCart){
  $('toastTxt').textContent=msg;$('toastBtn').style.display=withCart?'':'none';
  $('toast').classList.add('is-on');clearTimeout(toastT);toastT=setTimeout(()=>$('toast').classList.remove('is-on'),6000);
}
function openCart(){
  const d=document.querySelector('cart-drawer-component');
  if(d&&typeof d.open==='function'){try{d.open();return;}catch(e){}}
  location.href=((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/')+'cart';
}
let adding=false;
async function addLive(){
  const v=variantFor(st.size,st.sel.length);
  if(!v||!v.available){toast('This blend is not available right now');return;}
  if(adding)return;adding=true;
  const btns=[$('cartBtn'),$('mbBtn')];btns.forEach(b=>{b.disabled=true;b.textContent='Adding…';});
  let ev=null,deferred=null;
  try{ev=await import('@shopify/events');deferred=ev.CartLinesUpdateEvent.createPromise();}catch(e){}
  const sections=[...document.querySelectorAll('cart-items-component')].map(c=>c.dataset.sectionId).filter(Boolean);
  if(ev)document.dispatchEvent(new ev.CartLinesUpdateEvent({action:'add',context:'product',lines:[{merchandiseId:String(v.id),quantity:1}],promise:deferred.promise}));
  try{
    const base=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    const r=await fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify({items:[{id:v.id,quantity:1,properties:properties()}],sections:sections.join(',')})});
    const res=await r.json();
    if(!r.ok||res.status)throw new Error(res.description||res.message||'Could not add to cart');
    const cart=await fetch(base+'cart.js',{headers:{Accept:'application/json'}}).then(x=>x.json());
    if(deferred)deferred.resolve({cart:ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail:{items:cart.items,source:'ms-layering-studio',sourceId:'ms-layering-studio',itemCount:1,sections:res.sections,didError:false}});
    toast('Your blend is in the cart',true);
  }catch(e){
    if(deferred)deferred.reject(e);
    toast(e.message||'Could not add to cart, please try again');
  }finally{adding=false;renderSummary();}
}
const onAdd=()=>{if(!isReady())return;CFG.live?addLive():openPreview();};

/* ---------- events ---------- */
const go=s=>{const el=root.querySelector(`[data-step="${s}"]`)||$('summary');el.scrollIntoView({behavior:'smooth',block:'start'});};
$('stepsNav').addEventListener('click',e=>{const b=e.target.closest('button');if(b)go(b.dataset.s);});
$('sizes').addEventListener('click',e=>{const b=e.target.closest('.ls-size');if(!b)return;st.size=b.dataset.size;render();});
$('tiers').addEventListener('click',e=>{
  const c=e.target.closest('.ls-acc');if(!c)return;
  const more=e.target.closest('.ls-more');
  if(more){c.classList.toggle('is-open');more.setAttribute('aria-expanded',c.classList.contains('is-open'));return;}
  if(e.target.closest('.ls-acc-main')){if(c.classList.contains('is-off'))return;const {id,tier}=c.dataset;toggle(id,tier);
    const again=root.querySelector(`.ls-acc[data-id="${id}"][data-tier="${tier}"] .ls-acc-main`);if(again)again.focus({preventScroll:true});}
});
$('formula').addEventListener('click',e=>{const row=e.target.closest('.ls-f-row');if(!row)return;const i=+row.dataset.i;
  const b=e.target.closest('.ls-stp');if(b){setPct(i,st.sel[i].pct+ +b.dataset.d);render();return;}
  if(e.target.closest('.ls-rm')){st.sel.splice(i,1);if(!st.touched)autoBalance();render();}});
$('formula').addEventListener('input',e=>{if(e.target.type!=='range')return;setPct(+e.target.closest('.ls-f-row').dataset.i,+e.target.value);});
$('autoBtn').addEventListener('click',()=>{autoBalance();st.touched=false;render();});
[['nm','name','nmc'],['by','by','byc']].forEach(([id,key,cid])=>{const el=$(id);el.addEventListener('input',()=>{st[key]=el.value.trim();$(cid).textContent=el.value.length+'/25';renderSummary();renderProfile();});});
$('cartBtn').addEventListener('click',onAdd);
$('mbBtn').addEventListener('click',()=>{if(isReady())return onAdd();const r=ready();go(!r.size?1:!(r.top&&r.heart&&r.base)?2:!r.total?3:'sum');});
$('mClose').addEventListener('click',()=>$('modal').classList.remove('is-on'));
$('modal').addEventListener('click',e=>{if(e.target===$('modal'))$('modal').classList.remove('is-on');});
$('toastBtn').addEventListener('click',()=>{$('toast').classList.remove('is-on');openCart();});
document.addEventListener('keydown',e=>{if(e.key==='Escape')$('modal').classList.remove('is-on');});
window.__msls={st,render,autoBalance,properties,variantFor};      // test hook
// Deep link from the homepage teaser (or anywhere): ?top=a,b&heart=c&base=d&name=My%20Blend&size=50
let fromLink=false;
try{
  const q=new URLSearchParams(location.search);
  TIERS.forEach(t=>(q.get(t.id)||'').split(',').map(x=>x.trim()).filter(Boolean).forEach(id=>{
    const a=byId[id]; if(!a||!a.tiers.includes(t.id)||blockReason(a,t.id))return;
    if(st.sel.some(s=>s.id===id&&s.tier===t.id))return;
    st.sel.push({id,tier:t.id,pct:MINP}); fromLink=true;
  }));
  if(fromLink)autoBalance();
  const nm=(q.get('name')||'').trim().slice(0,25);
  if(nm){st.name=nm;$('nm').value=nm;$('nmc').textContent=nm.length+'/25';}
  if(q.get('size')==='50'||q.get('size')==='100')st.size=q.get('size');
}catch(e){}
render();
if(fromLink)setTimeout(()=>{        // accords already chosen: bring the next step (bottle, or formula if size given) into view if it is below the fold
  const el=root.querySelector(`[data-step="${st.size?3:1}"]`);
  if(el&&el.getBoundingClientRect().top>innerHeight*.6)el.scrollIntoView({block:'start'});
},300);
};

if(CFG.data)boot(CFG.data);
else if(CFG.dataUrl)fetch(CFG.dataUrl).then(r=>r.json()).then(boot).catch(e=>{console.error('[layering-studio]',e);
  const t=root.querySelector('[data-ls="tiers"]');if(t)t.innerHTML='<p>The Layering Studio could not load. Please refresh the page.</p>';});
})();
